// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import ModalContent from './ModalContent'
import { useBooleanToggle } from 'hooks'
import { FaQuestionCircle } from 'components/FontAwesome'
import { Modal } from 'reactstrap'

const Faq = () => {
  const [isOpen, toggleModal] = useBooleanToggle(false)

  return (
    <>
      <FaQuestionCircle
        className='cursor-pointer margin-right-1'
        onClick={toggleModal} />
      <Modal
        isOpen={isOpen}
        toggle={toggleModal}>
        <ModalContent toggleModal={toggleModal} />
      </Modal>
    </>
  )
}

export default Faq
